export default __webpack_public_path__ + "static/media/Alto.a384c2b2.png";